import { FC } from 'react'
import { observer } from 'mobx-react'
import { useTranslation } from 'next-i18next'
import { CustomSelectFieldGroup } from '@components-v2/molecules/CustomSelectFieldGroup'
import { OrderDirection, UserOrderBase, UserOrderField } from '@/types'
import styles from './index.module.scss'

type Props = {
  selectedValue: UserOrderBase
  setFieldValue: (userOrderField: UserOrderField) => void
}

export const KeywordSearchGroupFormSortOrderForAngels: FC<Props> = observer(({ selectedValue, setFieldValue }) => {
  const { t } = useTranslation(['angels-vcs-startups'])

  const allItems = [
    {
      id: UserOrderField.ANGEL_SCORE,
      name: t('おすすめ'),
      value: {
        userOrderField: UserOrderField.ANGEL_SCORE,
        direction: OrderDirection.DESC,
      },
    },
    {
      id: UserOrderField.CREATED_AT,
      name: t('新着'),
      value: {
        userOrderField: UserOrderField.CREATED_AT,
        direction: OrderDirection.DESC,
      },
    },
  ]

  const onSelect = (id: string) => {
    const target = allItems.find((item) => item.id === id)
    setFieldValue(target.value.userOrderField)
  }

  const selectedItem = allItems.find((item) => item.id === selectedValue.userOrderField)

  const selectableItems = allItems.map((item) => ({
    instance: item,
    isSelected: selectedItem && selectedItem.id === item.id,
  }))

  const emptyFuc = () => {}

  return (
    <div className={styles.container}>
      <div className={styles.left}>
        <div className={styles.label}>{t('並び替え')}:</div>
      </div>
      <div className={styles.right}>
        <CustomSelectFieldGroup
          placeholder={t('並び替え')}
          onSelect={onSelect}
          selectedItems={selectedItem ? [selectedItem] : []}
          selectableItems={selectableItems}
          isMultiple={false}
          onUnselect={emptyFuc}
          onUnselectAll={emptyFuc}
        />
      </div>
    </div>
  )
})
